import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { TrackingPage } from 'webapp/enums/tracking';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import DesignerTopbarPopupResolutionCenterComponent from 'webapp/components/designer/topbar/popup-resolution-center';
import ToolTipComponent from 'webapp/components/tool-tip';

export default class DesignerTopbarNotificationsComponent extends Component {
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('app-notifications') declare appNotificationsService: Service.AppNotifications;
	@service('popup') declare popupService: Service.Popup;

	get model() {
		return this.appNotificationsService.sortedVisibleNotifications;
	}

	get notificationsCount() {
		return this.model.length;
	}

	@action
	openPopup(event: Event) {
		const attachTo = (event.target as HTMLElement).closest<HTMLElement>('#notifications')!;

		if (!attachTo) {
			return;
		}

		const isPopupOpen = this.popupService.isOpen(DesignerTopbarPopupResolutionCenterComponent);

		if (!isPopupOpen) {
			this.analyticsService.page(TrackingPage.ALERT_CENTER);

			this.popupService
				.createContext(DesignerTopbarPopupResolutionCenterComponent, attachTo, {
					popupClass: 'popup-resolution-center',
				})
				.open();
		}
	}
	<template>
		{{#if this.notificationsCount}}
			<div id="notifications">
				<a role="button" {{on "click" this.openPopup}}>
					<CommonUiIconComponent
						@name="AlertFill"
						@size="sm"
						@class={{if this.notificationsCount "active"}}
					/>
					<small class="badge red">{{this.notificationsCount}}</small>
					<ToolTipComponent
						@text="Resolve issues"
						@theme="light"
						@position="right"
						@delay={{1}}
					/>
				</a>
			</div>
		{{/if}}
	</template>
}
